import React from 'react';
import I18N from '../I18N';
import API from '../API';
import { Apify } from '../Apify';
import { Col, Container, Row, Table } from 'reactstrap';
import { A, R } from '../routes';

import Butt from './Butt';
import { T } from '../traks';
import Countdown from './Countdown';
import { ProgressPie } from './Progress';

var QueuedTrades = (props) => {
	if (props.error) return null;
	if (props.queue === null || props.queue.length === 0) return <div className={props.empty_class}/>;

	let queue = [...props.queue];

	queue.sort((a,b) => {
		return a.Id - b.Id;
	});

	const rows = queue.map((qt) => {
		let waiting_element = null;
		let cancel_element = null;
		let now = Date.now()/1000;
		if (qt.CancelEffectiveTs === 0) {
			const do_cancel = () => {
				API.post("/a/cancel_queued_trade", {id: qt.Id}, () => {
					props.ctl.reload();
				});
			};
			cancel_element = <Butt className="align-self-start ml-0 ml-lg-auto btn-red" onClick={do_cancel}><T>Cancel</T></Butt>;
			let next_ts = qt.NextTradeTs;
			if (next_ts > now) {
				// XXX the implementation of this countdown
				// stuff is questionable because it combines
				// render-time choices with dynamic updates...
				let countdown =
					(next_ts - now) >= (60*60)
					? (<React.Fragment><Countdown end_time={next_ts}/></React.Fragment>)
					: (<React.Fragment><Countdown only_minutes end_time={next_ts}/>&nbsp;<T>minutes</T></React.Fragment>)
				waiting_element = <span><T>Trades in approx.</T> {countdown}</span>;
			} else {
				waiting_element = (
					<React.Fragment>
						<span className="align-self-start align-self-lg-end pr-1 fw-bold"><T>Trade in progress</T>:</span>
						<span className="whitespace-wrap align-self-start align-self-lg-end"><T><strong>Note:</strong> trades in stocks with low volume can take a long time to complete.</T></span>
					</React.Fragment>
				);
			}
		} else {
			cancel_element = (
				<React.Fragment>
					<span className="ad_main_red fw-bold text-left text-md-right"><T>Cancels in approx.</T>: <Countdown only_minutes end_time={qt.CancelEffectiveTs}/>&nbsp;<T>minutes</T></span>
					<span className="text-left text-md-right">Du har anmodet om en annullering. Vær opmærksom på at handler stadig kan gå igennem.</span>
				</React.Fragment>
			);
		}

		const ticker_element = (
			<A className="txt-color-green fw-bold" href={R.href("/ticker/:exchange/:ticker", {exchange: qt.Exchange, ticker: qt.Ticker})}>
				{qt.StockName} ({qt.Ticker})
			</A>
		);

		let what = null;
		let progress_fraction = 0;
		if (qt.BuyWithAmount > 0) {
			const orig_amount = I18N.floatval_unit(qt.BuyWithAmount, qt.BankrollNDecimals, qt.Currency);
			const current_amount = I18N.floatval_unit(qt.BuyWithAmount - qt.Progress, qt.BankrollNDecimals, qt.Currency);
			if (qt.Progress) {
				what = <T>Buy {ticker_element} for {current_amount} (was {orig_amount})</T>;
			} else {
				what = <T>Buy {ticker_element} for {current_amount}</T>;
			}
			progress_fraction = qt.Progress / qt.BuyWithAmount;
		} else if (qt.SellQuantity > 0) {
			const orig_sale_amount = I18N.floatval(qt.SellQuantity, qt.StockNDecimals);
			const current_sale_amount = I18N.floatval(qt.SellQuantity - qt.Progress, qt.StockNDecimals);
			if (qt.Progress) {
				what = <T>Sell {current_sale_amount} (was {orig_sale_amount}) {ticker_element}</T>;
			} else {
				what = <T>Sell {current_sale_amount} {ticker_element}</T>;
			}
			progress_fraction = qt.Progress / qt.SellQuantity;
		}

		return (
			<tr class="d-flex justify-content-between flex-wrap border-bottom border-white" key={qt.Id}>
				<td className="align-self-center">
				{what}
				</td>
				<td className="d-flex flex-column ad_cancel_element">
				{cancel_element}
				</td>
				<td className="w-100 d-flex pb-3 align-items-start align-items-lg-end flex-column pt-0 pb-3">
				{waiting_element}
				</td>
			</tr>
		);
	});

	return (
		<Container className="px-0 ad_queued_trades">
			<Row className="ad_game_box">
				<Col className="pl-2 pl-md-4" xs="12">
					<div className="pt-4 pb-3 pb-0 ad_150pct"><b><T>Trades in queue</T></b></div>
				</Col>
				<Col xs="12" className="pt-3 px-2 px-md-4">
					<Table size="sm" className="txt-color-white">
						<tbody>
							{rows}
						</tbody>
					</Table>
				</Col>
			</Row>
		</Container>
	);
}

QueuedTrades = Apify("/a/trade_queue")
	.with_query_from_props(props => ({portfolio_id: props.portfolio_id}))
	.with_response_prop("queue")
	.with_4xx_prop("error")
	.with_ctl_prop()
	.with_refresh_interval(60)
	.wrap(QueuedTrades);

export default QueuedTrades;



// WEBPACK FOOTER //
// ./src/c/QueuedTrades.js